module.exports = __webpack_public_path__ + "img/224.c07ded0f.jpg";